export interface IRouteNode {
  path: string;
  children: IRouteNode[];
  id: number;
  name: string;
  parentRouteId: number;
  hidden: boolean;
  icon: string;
}
